import React, { useEffect } from "react";
import Hero from "../components/Hero";
import ProductsShowcase from "../components/sections/ProductsShowcase";
import WhyWeldmatix from "../components/sections/WhyWeldmatix";
import IndustriesSection from "../components/sections/IndustriesSection";
import TechnologySection from "../components/sections/TechnologySection";
import ManufacturingProcess from "../components/sections/ManufacturingProcess";
import BrochureSection from "../components/sections/BrochureSection";
import ProjectsSection from "../components/sections/ProjectsSection";
import EnquiryForm from "../components/EnquiryForm";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function HomePage() {
  useEffect(() => {
    document.title = "Weldmatix Fusion — Advanced Welding Automation & Weld Overlay Solutions";
  }, []);

  return (
    <div data-testid="page-home">
      <Hero />
      <ProductsShowcase />
      <WhyWeldmatix />
      <IndustriesSection />
      <TechnologySection />
      <ManufacturingProcess />
      <BrochureSection />
      <ProjectsSection />

      {/* Global Support strip */}
      <section data-testid="global-support" className="relative bg-[#F8FAFC] py-24 md:py-32 border-t border-[#E2E8F0] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-7">
            <div className="eyebrow mb-4">// Global Support · 07</div>
            <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[0.95]">
              Engineering Excellence.<br /><span className="text-[#0EA5E9]">Global Reach.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#475569] max-w-xl leading-relaxed">
              Supporting customers across energy, process and manufacturing industries
              through advanced automation solutions and responsive technical support — wherever you operate.
            </p>
          </div>
          <div className="md:col-span-5">
            <div className="grid grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
              {[
                { k: "Continents", v: "5" },
                { k: "Avg Response", v: "<24h" },
                { k: "Languages", v: "8+" },
                { k: "Remote Diagnostics", v: "24×7" }
              ].map((s) => (
                <div key={s.k} className="bg-[#FFFFFF] p-6">
                  <div className="font-display text-3xl md:text-4xl text-slate-900">{s.v}</div>
                  <div className="font-mono-wm text-[10px] tracking-[0.25em] uppercase text-[#64748B] mt-2">{s.k}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Lead generation */}
      <section data-testid="home-enquiry" className="relative bg-white py-24 md:py-32 border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="eyebrow mb-4">// Enquiry · 08</div>
            <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-5xl leading-[0.95]">
              Let's engineer your<br /><span className="text-[#0EA5E9]">next solution.</span>
            </h2>
            <p className="mt-6 text-[#475569] leading-relaxed">
              Tell us about your application — our engineering team will respond with a
              tailored proposal, technical specs and a recommended system configuration.
            </p>
            <div className="mt-10 space-y-4">
              {[
                "Engineering-led proposal within 24h",
                "Direct line to design engineers",
                "Confidential & NDA-friendly review"
              ].map((b) => (
                <div key={b} className="flex items-center gap-3 text-sm text-[#0F172A]">
                  <span className="w-6 h-px bg-[#0EA5E9]" /> {b}
                </div>
              ))}
            </div>
            <Link to="/contact" data-testid="home-contact-link" className="mt-10 inline-flex items-center gap-3 font-mono-wm text-xs tracking-[0.25em] uppercase text-[#475569] hover:text-slate-900">
              View full contact page <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="md:col-span-7">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}
